// extracted by mini-css-extract-plugin
export default {"hed":"hed__NjY5N","realWeddingCard":"realWeddingCard__ZDVjM"};